import axios from "./Axios";

export const predictAudio = ({ audio, type }) => {
  let config = {
    header: {
      "Content-Type": "multipart/form-data",
    },
  };
  let data = new FormData();
  const file = type === "blob" ? blobToFile(audio, "test.wav") : audio;
  data.append("audio", file, file.name);
  return axios.post("/moodlink-api/", data, config);
};

function blobToFile(theBlob, fileName) {
  const file = new File([theBlob], fileName, {
    lastModified: new Date().getTime(),
    type: theBlob.type,
  });
  console.log(file);
  return file;
}
